export type ValidationStep = "step_1" | "step_2" | "step_3";
export type ValidationStatus = "pending" | "validated" | "rejected";

export interface ValidationEvent {
  id: number;
  fund_id: number;
  quarter: string;
  step: ValidationStep;
  step_label: string;
  status: ValidationStatus;
  user_email: string;
  comment?: string | null;
  created_at: string;
}

export interface CreateValidationEventPayload {
  fund_id: number;
  quarter: string;
  step: ValidationStep;
  status: ValidationStatus;
  comment?: string;
}

export const STEP_CONFIG: Record<
  ValidationStep,
  { label: string; color: string; textColor: string; borderColor: string }
> = {
  step_1: {
    label: "Validation by Quantilia",
    color: "bg-blue-50",
    textColor: "text-blue-700",
    borderColor: "border-blue-200",
  },
  step_2: {
    label: "R1 Validation N°1",
    color: "bg-blue-50",
    textColor: "text-blue-700",
    borderColor: "border-blue-200",
  },
  step_3: {
    label: "R1 Validation N°2",
    color: "bg-blue-50",
    textColor: "text-blue-700",
    borderColor: "border-blue-200",
  },
};

export const STATUS_CONFIG: Record<
  ValidationStatus,
  { label: string; icon: string; badgeClass: string }
> = {
  pending: {
    label: "Pending",
    icon: "⏳",
    badgeClass: "bg-slate-100 text-slate-600",
  },
  validated: {
    label: "Validated",
    icon: "✓",
    badgeClass: "bg-green-100 text-green-700",
  },
  rejected: {
    label: "Rejected",
    icon: "✗",
    badgeClass: "bg-red-100 text-red-700",
  },
};
